"use client";
import { createContext, ReactNode, useContext } from "react";
import { useSocket } from "../Chat/useSocket";
import { PendingCall, usePendingCalls } from "./usePendingCalls";

interface PendingCallsContextValue {
	calls: PendingCall[];
	dismissCall: (id: string) => void;
}

const PendingCallsContext = createContext<PendingCallsContextValue>({
	calls: [],
	dismissCall: () => {},
});

export function PendingCallsProvider({ children }: { children: ReactNode }) {
	const socket = useSocket();
	const { calls, dismissCall } = usePendingCalls(socket);

	return (
		<PendingCallsContext.Provider value={{ calls, dismissCall }}>
			{children}
		</PendingCallsContext.Provider>
	);
}

export const usePendingCallsContext = () => useContext(PendingCallsContext);
